/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React, { useContext } from "react"
import { useFormContext } from "react-hook-form"
import { SingleShorty, TwoColumnRow } from "./Shared"
import { ChangePasswordContext } from "../../containers/account/ChangePasswordContainer"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { Button, Stack, useTheme } from "@carrotfertility/carotene-core"
import { FormattedMessage, useIntl } from "react-intl"

const Footer = () => {
  const { toggleIsOpen, onSubmit } = useContext(ChangePasswordContext)
  const {
    formState: { isSubmitting }
  } = useFormContext()
  const theme = useTheme()

  return (
    <Stack direction="row" spacing={theme.spacing(theme.tokens.spacing.md)}>
      <Button onClick={toggleIsOpen} variant="outlined">
        <FormattedMessage defaultMessage="Cancel" />
      </Button>

      <Button onClick={onSubmit}>
        {isSubmitting ? (
          <FormattedMessage defaultMessage="Submitting..." />
        ) : (
          <FormattedMessage defaultMessage="Update now" />
        )}
      </Button>
    </Stack>
  )
}

const CurrentPassword = () => {
  const {
    formState: { errors },
    register
  } = useFormContext()
  const intl = useIntl()

  return (
    <CompleteFormInput
      type="password"
      label={intl.formatMessage({ defaultMessage: "Current password" })}
      errors={errors}
      {...register("currentPassword", {
        required: intl.formatMessage({ defaultMessage: "Current password is required" })
      })}
    />
  )
}

const NewPassword = () => {
  const {
    formState: { errors },
    register
  } = useFormContext()
  const intl = useIntl()

  return (
    <CompleteFormInput
      type="password"
      label={intl.formatMessage({ defaultMessage: "New password" })}
      errors={errors}
      {...register("newPassword", {
        required: intl.formatMessage({ defaultMessage: "Password is required" }),
        minLength: {
          message: intl.formatMessage({ defaultMessage: "Min 8 characters" }),
          value: 8
        }
      })}
    />
  )
}

const ConfirmPassword = () => {
  const {
    formState: { errors },
    register,
    watch
  } = useFormContext()
  const newPassword = watch("newPassword")
  const intl = useIntl()

  return (
    <CompleteFormInput
      type="password"
      label={intl.formatMessage({ defaultMessage: "Confirm password" })}
      errors={errors}
      {...register("confirmNewPassword", {
        required: intl.formatMessage({ defaultMessage: "Confirmation is required" }),
        validate: (value) => value === newPassword || intl.formatMessage({ defaultMessage: "Password must match" })
      })}
    />
  )
}

const ChangePassword = () => (
  <>
    <SingleShorty>
      <CurrentPassword />
    </SingleShorty>
    <TwoColumnRow left={<NewPassword />} right={<ConfirmPassword />} />
    <Footer />
  </>
)

const ChangePasswordPreview = () => {
  const { toggleIsOpen } = useContext(ChangePasswordContext)

  return (
    <Button variant="outlined" color="secondary" onClick={toggleIsOpen}>
      <FormattedMessage defaultMessage="Change password" />
    </Button>
  )
}

export { ChangePassword, ChangePasswordPreview }
